export const UPDATE_REGION_LIST = 'updateRegionList';

// get regions sorted by latency
export const getRegions = async () => {
  const zones = window.app?.zones ?? [];

  try {
    const regionsString = window.localStorage.getItem('regions');
    const regions = JSON.parse(regionsString);
    const regionNames = regions.map(region => region.name);
    if (
      Array.isArray(regions) &&
      zones.length === regions.length &&
      zones.every(zone => regionNames.includes(zone))
    ) return regions;
    // eslint-disable-next-line no-empty
  } catch { }


  const promises = zones.map((zone) => new Promise((resolve) => {
    const start = new Date();
    fetch(`https://ec2.${zone}.amazonaws.com/ping`).finally(() => {
      const end = new Date();
      resolve(end - start);
    });
  }));
  const latency = await Promise.all(promises);
  return zones.map((zone, index) => ({ name: zone, latency: latency[index] })).sort((a, b) => a.latency - b.latency);
};

// check region for redirection
export const redirect = async () => {
  const regions = await getRegions();
  // look for region in uri
  const uriRegionIndex = regions.findIndex((region) => window.location.origin.includes(region.name));
  if (uriRegionIndex > -1) {
    regions[uriRegionIndex] = regions.splice(0, 1, regions[uriRegionIndex])[0];
    window.localStorage.setItem('regions', JSON.stringify(regions));
    window.dispatchEvent(new CustomEvent(UPDATE_REGION_LIST));
    document.querySelector('#root').classList.remove('hidden');
  } else {
    const { location: { host, protocol } } = window;
    const subdomain = regions[0]?.name ? `${regions[0]?.name}.` : '';
    window.location.href = `${protocol}//${subdomain}${host.replace('global.', '')}`;
  }
};
